import React, { useEffect, useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { TextField } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@material-ui/core/Button';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';
import { dataService } from '../../../Services/data.service';
import AlertDialog from './AlertDialog';
import { roles } from '../../../Config/authConstants';

export default function CredentialsPloegChefDialog(props) {

    const classes = useStyles();
    const [ploegChefAanwezig, setPloegChefAanwezig] = useState(true)
    const [username, setUsername] = useState(null)
    const [password, setPassword] = useState(null)
    const [alertDialogOpen, setAlertDialogOpen] = useState(false)
    const [dialogTitle, setDialogTitle] = useState(null)
    const [dialogContext, setDialogContext] = useState(null)
    const { t } = useTranslation();

    useEffect(() => {
        setUsername(null)
        setPassword(null)
    }, [props.dialogOpen])

    const validate = () => {
        if (!ploegChefAanwezig) {
            return true
        }
        if (!username || !password) {
            return false
        }

        return true
    }

    const togglePloegChef = () => {
        setPloegChefAanwezig(!ploegChefAanwezig)
    }

    const usernameChanged = (event) => {
        setUsername(event.target.value)
    }

    const passwordChanged = (event) => {
        setPassword(event.target.value)
    }

    const closeAlertDialog = () => {
        setAlertDialogOpen(false)
    }

    const validateCredentials = () => {
        if (!ploegChefAanwezig) {
            props.action(true)
            props.closeDialog()
        }
        let roleArray = [roles.PLOEGCHEF, roles.ADMINISTRATOR]
        dataService.validateAndHasRole(username, password, roleArray).then((result) => {

            if (result.succeeded) {
                props.action(true)
                props.closeDialog()
            }
            else {
                setDialogTitle("Permission denied!")
                setDialogContext(result.messages[0])
                setAlertDialogOpen(true)
            }
        })
    }

    return (
        <React.Fragment>
            <Dialog className={classes.dialogContainer}
                open={props.dialogOpen}
                aria-labelledby="draggable-dialog-title"
                onClose={props.closeDialog}
            >
                <div className={classes.dialogTitle} style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {props.dialogTitle}
                </div>
                <div className={classes.label}>{t("Username")}</div>
                <TextField disabled={!ploegChefAanwezig} id="outlined-search" size="small" label="" type="search" variant="outlined" value={username} className={classes.uiTextField} onChange={(e) => usernameChanged(e)} />
                <div className={classes.label} style={{ marginTop: "10px" }}>{t("Password")}</div>
                <TextField disabled={!ploegChefAanwezig} id="outlined-search" size="small" label="" type="password" variant="outlined" value={password} className={classes.uiTextField} onChange={(e) => passwordChanged(e)} />
                <DialogActions>
                    <div className={classes.buttons}>
                        <Button className={classes.cancelButton} onClick={() => props.closeDialog()}>
                            {t("CANCEL")}
                        </Button>
                        <Button className={classes.okButton} disabled={!validate()} onClick={() => validateCredentials()}>
                            {t("OK")}
                        </Button>
                    </div>
                </DialogActions>
                <FormControlLabel control={<Checkbox onChange={togglePloegChef} />} label={t("Team leader not present")} />
            </Dialog>
            <AlertDialog dialogOpen={alertDialogOpen} closeDialog={closeAlertDialog} action={closeAlertDialog} dialogTitle={dialogTitle} dialogContext={dialogContext}></AlertDialog>
        </React.Fragment>

    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "620px !important",
        height: "auto !important",
        margin: "auto",
        "& > div > div": {
            backgroundImage: 'linear-gradient(#EFEFEF,#FFFFFF)'
        },
    },
    buttons: {
        textAlign: "center",
        marginLeft: "auto",
        marginRight: "auto",
        width: "235px",
        marginBottom: "20px"
    },
    okButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
        margin: "3px",
        width: "110px",
        marginBottom: "30px",
        marginTop: "20px",
        float: "left"
    },
    cancelButton: {
        color: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: "#E6E8FE",
        '&:hover': {
            backgroundColor: "#E6E8FE",
        },
        margin: "3px",
        width: "110px",
        marginBottom: "30px",
        marginTop: "20px",
        float: "left"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        fontSize: "32px !important",
        paddingTop: "0px",
        paddingBottom: "0px",
        marginTop: "50px",
        marginBottom: "20px",
        width: "520px"
    },
    uiTextField: {
        width: "300px",
        backgroundColor: "white",
        marginRight: "auto",
        marginLeft: "auto"
    },
    textField: {
        width: "300px",
        marginRight: "auto",
        marginLeft: "auto"
    },
    label: {
        color: "#000000",
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        width: "300px",
        marginRight: "auto",
        marginLeft: "auto",
        marginTop: "5px"
    },
}));
